import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MainHolder,
  StyledText,
} from "../../../../components/common";
import styled from "styled-components";
import { NewBackButton, NoticeIcon } from "../../../../components/svgs";
// import useTimer from "../../../../hooks/useTimer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLoyalty, useTheme } from "../../../../hooks";
// import useCountDown from "../hooks/timer";

import winnersPhoto from "../../../../components/images/motivation_man.png";
import { ConfirmVoteModal, ContestantVotingCard } from "../components";
import { BusinessChallengeService } from "../../../../services";

const VotingPage = () => {
  const { themeContext, theme } = useTheme();
  const [contestants, setContestants] = useState([]);
  const [loadingContestants, setLoadingContestants] = useState(false);
  const history = useHistory();
  const [openConfirmVoteModal, setOpenConfirmVoteModal] = useState(false);
  const [selectedContestant, setSelectedContestant] = useState();
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const token = JSON.parse(localStorage.getItem("token"));
  const { businessChallengeVotingDetails, getVotingDetails } = useLoyalty();
  const { isActive, hasVoted, hasEnded } = businessChallengeVotingDetails || {};

  const isCompleted = hasEnded;

  const contestantWithHighestVotes = contestants.find(contestant => contestant.isWinner);

  const handleVote = () => {
    return BusinessChallengeService.vote(token, {
      contestantId: selectedContestant._id,
    })
      .then(() => getVotingDetails())
  }

  const getContestants = () => {
    setLoadingContestants(true);
    BusinessChallengeService.getContestants(token)
      .then(data => {
        const { data: contestantsData } = data;
        if (contestantsData) setContestants(contestantsData)
      })
      .catch(e => console.log(e))
      .finally(() => setLoadingContestants(false))
  };

  useEffect(() => {
    getContestants();
  }, []);

  useEffect(() => {
    if (hasVoted && !hasEnded) {
      history.push('/business_challenge/poll_page')
    }
  }, [hasVoted, hasEnded])
  return (
    <>
      <MainHolder
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: isCompleted ? "#0FAF4B" : "#EE2737",
            paddingLeft: 15,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          <div style={{ position: "absolute" }}>
            <BackButtonContainer
              onClick={() => {
                history.goBack();
              }}
            >
              <NewBackButton />
            </BackButtonContainer>
          </div>
          <Box
            style={{
              display: "flex",
              flex: 1,
              backgroundColor: isCompleted ? "#0FAF4B" : "#EE2737",
              justifyContent: "center",
            }}
          >
            <StyledText style={{ fontSize: 18, color: "white" }}>
              {/* {isCompleted
                ? "Voting period ended"
                : `Voting ends in ${days}d:${minutes}hrs:${seconds}s`} */}
            </StyledText>
          </Box>
        </Box>
        {!isCompleted && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 20,
            }}
          >
            <StyledText>Business Challenge Voting</StyledText>
            <StyledText
              style={{ textAlign: "center", fontFamily: "MTNRegular" }}
            >
              Vote for your favorite Business Challenge participants.
            </StyledText>
            {contestants.map((contestant) => (
              <ContestantVotingCard
                isVoting={!hasVoted}
                businessDescription={contestant.description}
                businessName={contestant.sector}
                imgUrl={contestant.imageUrl}
                teamName={contestant.name}
                key={contestant._id}
                onClick={() => {
                  setOpenConfirmVoteModal(true);
                  setSelectedContestant(contestant);
                }}
              />
            ))}
          </div>
        )}

        {isCompleted && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 20,
            }}
          >
            <StyledText
              style={{
                fontSize: 20,
                width: "70%",
                textAlign: "center",
                margin: 0,
              }}
            >
              Business Challenge final results!
            </StyledText>
            <StyledText
              style={{ textAlign: "center", fontFamily: "MTNRegular" }}
            >
              We have a winner!
              <span style={{ fontFamily: "MTNBold" }}>
                {" "}
                Team {contestantWithHighestVotes?.name}{" "}
              </span>
              are the ultimate champions of the Business Challenge. Thank you
              for participating, and stay tuned for more exciting events!
            </StyledText>
            <HorizontalSeparator />
            <StyledText
              style={{
                color: background,
                marginTop: 20,
                fontSize: 25,
                marginBottom: 0,
              }}
            >
              WINNER
            </StyledText>
            <ContestantVotingCard
              businessDescription={contestantWithHighestVotes?.description}
              businessName={contestantWithHighestVotes?.sector}
              imgUrl={contestantWithHighestVotes?.imageUrl}
              teamName={contestantWithHighestVotes?.name}
              key={contestantWithHighestVotes?._id}
            />

            {/* <Button
              style={{
                backgroundColor: background,
                width: "60%",
                alignSelf: "center",
              }}
              onClick={() => history.push("/business_challenge/poll_page")}
            >
              <StyledText color="white">View Poll</StyledText>
            </Button> */}
          </div>
        )}
      </MainHolder>
      {openConfirmVoteModal && (
        <ConfirmVoteModal
          onBackDropClick={() => setOpenConfirmVoteModal(false)}
          teamName={selectedContestant?.name}
          onVote={() => handleVote()}
        />
      )}
    </>
  );
};

export default VotingPage;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HorizontalSeparator = styled.div`
  width: 100%;
  height: 0.1px;
  background-color: #7f7f7f;
  margin-top: 15px;
`;
// const constestants = [
//   {
//     id: 1,
//     has_won: true,
//     business_name: "The Jaon",
//     team_name: " Jaon",
//     business_description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lacus libero, faucibus vitae nisl in, dapibus commodo orci.",
//     photo: winnersPhoto,
//     votes: 90,
//   },
//   {
//     id: 2,
//     has_won: false,
//     business_name: "The Majid",
//     team_name: "Majid",
//     business_description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lacus libero, faucibus vitae nisl in, dapibus commodo orci.",
//     photo: winnersPhoto,
//     votes: 23,
//   },
//   {
//     id: 3,
//     has_won: false,
//     business_name: "The Rainer",
//     team_name: "Rainer",
//     business_description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lacus libero, faucibus vitae nisl in, dapibus commodo orci.",
//     photo: winnersPhoto,
//     votes: 50,
//   },
//   {
//     id: 4,
//     has_won: false,
//     business_name: "The Peace & Love",
//     team_name: "Peace & Love",
//     business_description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lacus libero, faucibus vitae nisl in, dapibus commodo orci.",
//     photo: winnersPhoto,
//     votes: 70,
//   },
// ];
